import HttpService from "../../SharedModule/utils/api";
const BASE_URL = "/products/Users";

// ASUITE11-2806: could use new endpoint in auth.tsx and delete this one
function getUserRolesForProductsModule(): Promise<any> {
    return HttpService.req(`${BASE_URL}/roles`);
  }
  
  export const UsersProductsService = {
    getUserRolesForProductsModule
  };